// Porta leve (A06): manifesto, busca e catálogo para src/app e src/routes; a tela por import().
export { productDebitAccountScreen } from './product-debit-account.screen';
export { productDebitAccountSearch } from './product-debit-account.search';
export { loadProductDebitAccountMessages } from './product-debit-account.catalog';
export const loadProductDebitAccountScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadProductDebitAccountGuides = () => import('./product-debit-account.guide');
